<template>
  <div class="Vue-Toastification__toast-body">
    <span>{{ mensagem }}</span>

    <button
      v-if="mostrarBotao"
      class="btn btn-sm btn-light btn-active-light-primary ms-6"
      @click="abrirMensagem"
    >
      {{ textoBotao }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    mensagem: {
      type: String,
      required: true,
    },
    mostrarBotao: {
      type: Boolean,
      default: true,
    },
    textoBotao: {
      type: String,
      default: "Abrir",
    },
  },
  methods: {
    abrirMensagem() {
      this.$emit("abrirMensagem");
    },
  },
};
</script>
